export class FooterTextDataIT {
    static readonly htmlLabel = {
        privacyPolicy: 'Informativa sulla Privacy',
        poweredBy: 'Offerto da Continual Engine',
    };
    static readonly snackbarLabels = {

    };
    static readonly tooltipLabels = {

    }
}